export const OPERATING_HOURS = {
  // Hours in 24-hour format
  OPEN_HOUR: 8,    // 8 AM
  CLOSE_HOUR: 21,  // 9 PM
  // Configure the last bookable start time (usually before closing)
  LAST_START_HOUR: 20,  // 8 PM
  LAST_START_MINUTE: 45, // :45 (last available start time is 8:45 PM)
  // Configure time increments
  MINUTE_INCREMENTS: 15, // 15-minute increments
  MIN_BOOKING_DURATION: 30 // Minimum booking duration in minutes
};
